const SEND_TIME_VALUES = [
  '08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30',
  '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30',
  '16:00', '16:30', '17:00', '17:30', '18:00', '18:30', '19:00', '19:30',
  '20:00', '20:30',
]

export const formatSendTime = (value: string): string => {
  const [hours, minutes] = value.split(':').map(Number)
  const period = hours < 12 ? 'AM' : 'PM'
  const hour = hours % 12 === 0 ? 12 : hours % 12
  return `${hour}:${String(minutes).padStart(2, '0')} ${period}`
}

export const sendTimeOptions = SEND_TIME_VALUES.map(value => ({ label: formatSendTime(value), value }))

export const timeOptions = SEND_TIME_VALUES.map(value => ({ label: formatSendTime(value), value: formatSendTime(value) }))

export const DEFAULT_SEND_TIME = '12:00'
